import React from 'react';

import Autocomplete from '../inputs/Autocomplete';

const PromotionsAutocomplete = ({ value, promotions, ...rest }) => {
    return (
        <Autocomplete
            size='small'
            name='promotions'
            fullWidth
            options={promotions || []}
            value={value || []}
            {...rest}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option.value === value}
            TextProps={{
                label: 'Promocion',
                autoFocus: true,
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    <span color='secondary'>{option.name}</span>
                </li>)}
        />
    );
}

export default PromotionsAutocomplete;